import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreRoutingModule } from './store-routing.module';
import { StoreComponent } from './store.component';
import { ProductCollectionComponent } from './product-collection/product-collection.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { StoreHeaderComponent } from './store-header/store-header.component';
import { StoreFaqComponent } from './store-faq/store-faq.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ProductComponent } from './product/product.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { IconsModule } from 'app/icons/icons.module';

@NgModule({
    declarations: [StoreComponent, ProductCollectionComponent, ProductCardComponent, StoreHeaderComponent, StoreFaqComponent, ProductComponent],
    imports: [CommonModule, StoreRoutingModule, MatProgressSpinnerModule, SlickCarouselModule, MatSnackBarModule, IconsModule],
})
export class StoreModule { }
